import { db, functions, storage } from '@/firebase'
import firebase from 'firebase'
import jsPDF from 'jspdf'
import moment from 'moment'

export default {

  getContratos({ commit }) {
    return db.collection('contratos').doc('contratos').collection('listado').get()
      .then(snap => {
        commit('setContratos', snap.docs.map(c => {
          return {
            ...c.data(),
            id: c.id
          }
        })
        )
      })
  },
  getContratosNegocio({ commit, rootState }) {
    const negocio = rootState.app.negocioGest;
    return db.collection('contratos').doc('contratos')
      .collection('listado')
      .where('negocio', '==', negocio)
      .where('visible', '==', true)
      .get()
      .then(snap => {
        commit('setContratosNegocio', snap.docs.map(c => {
          return {
            ...c.data(),
            id: c.id
          }
        })
        )
      })
  },
  getContratosPartner({ rootState, commit }) {
    const partner = rootState.app.partner.id;
    return db.collection('contratos').doc('contratos')
      .collection('listado')
      .where('cliente', '==', partner)
      .where('visible', '==', true)
      .get()
      .then(snap => {
        commit('setContratosPartner', snap.docs.map(c => {
          return {
            ...c.data(),
            id: c.id
          }
        })
        )
      })
  },

  getContratosRestaurante({ commit, rootState }) {
    return db.collection('contratos').doc('contratos')
      .collection('listado')
      .where('restaurante', 'in', rootState.app.restauranteGest)
      .where('visible', '==', true)
      .get()
      .then(snap => {
        commit('setContratosRestaurante', snap.docs.map(c => {
          return {
            ...c.data(),
            id: c.id
          }
        })
        )
      })
  },
  getContratosDirectorio({ commit, rootState }) {
    return db.collection('contratos').doc('contratos')
      .collection('listado')
      .where('directorio', '==', rootState.app.directorioGest)
      .where('visible', '==', true)
      .get()
      .then(snap => {
        commit('setContratosDirectorio', snap.docs.map(c => {
          return {
            ...c.data(),
            id: c.id
          }
        })
        )
      })
  },
  getContrato({ }, id) {
    return db.collection('contratos').doc('contratos').collection('listado').doc(id).get()
      .then(c => {
        if (c.exists) {
          return {
            ...c.data(),
            id: c.id
          }
        } else {
          return Promise.reject("no encontrado")
        }
      })
  },
  getPlantillas({ commit }) {
    var tipos = functions.httpsCallable('httpContratosTiposContrato');
    return tipos()
      .then(r => {
        commit('setPlantillas', r.data)
      })
  },
  savePlantilla({ }, plantilla) {
    let id = plantilla.id;
    delete plantilla.id;
    if (id) {
      return db.collection('contratos').doc('plantillas')
        .collection('listado').doc(id).set(
          plantilla,
          { merge: true }
        )
    } else {
      return db.collection('contratos').doc('plantillas')
        .collection('listado').add(
          plantilla)
    }
  },
  eliminarPlantilla({ }, id) {
    return db.collection('contratos').doc('plantillas')
      .collection('listado').doc(id).delete()
  },

  generarContrato({ rootState }, contrato) {
    let ficheros = contrato.ficheros;
    var idC;
    delete contrato.ficheros;
    contrato.historial = firebase.firestore.FieldValue.arrayUnion({
      accion: 'generado',
      mensaje: 'Contrato generado', fecha: moment().unix(),

      usuario: (rootState.auth.user) ? rootState.auth.user.email : 'Sin Datos',
    })
    contrato.estado = 'generado';
    return db.collection('contratos').doc('contratos').collection('listado').add(contrato)
      .then((cAdded) => {
        idC = cAdded.id;
        var promesasFile = [];
        if (ficheros && ficheros.length > 0) {
          var ficherosSave = [];
          ficheros.forEach(f => {
            var storageRef = storage.ref();
            let s = 'contratos/' + contrato.negocio + '/' + contrato.cliente + '/contrato_' + idC + '/' + f.name;
            var ref = storageRef.child(s);
            promesasFile.push(
              ref.put(f)
                .then((r) => {
                  return r.ref.getDownloadURL()
                })
                .then(r => {
                  ficherosSave.push({
                    url: r,
                    nombre: f.name,
                  })
                  return
                })
                .catch(e => console.log(e))

            )
          })
          return Promise.all(promesasFile)
            .then(() => {
              return db.collection('contratos').doc('contratos').collection('listado').doc(idC).set({
                ficheros: ficherosSave,
                historial: firebase.firestore.FieldValue.arrayUnion({
                  accion: 'ficheros adjuntados',
                  fecha: moment().unix(),
                  mensaje: ficherosSave.length > 1 ? ficherosSave.length + ' ficheros adjuntados' : ficherosSave.length + ' fichero adjuntado',
                  usuario: (rootState.auth.user) ? rootState.auth.user.email : 'Sin Datos',
                  adicional: ficherosSave
                })
              }, { merge: true })

            })
            .catch(e => console.log)
        } else {

        }
      })
      .catch(e => console.log(e))

  },
  cambiarVisibilidad({ }, contrato) {
    return db.collection('contratos').doc('contratos').collection('listado').doc(contrato.id).set({
      visible: contrato.visible
    }, { merge: true })


  },
  eliminarContrato({ }, id) {
    return db.collection('contratos').doc('contratos')
      .collection('listado').doc(id).delete()
  },
  generarFirma({ }, payload) {
    var firma = functions.httpsCallable('httpContratosGenerarFirma');
    return firma(payload).then(r => r.data)
  },
  comprobarContrato({ }, payload) {
    var comprobar = functions.httpsCallable('httpContratosComprobarFirma');
    return comprobar(payload).then(r => r.data).catch(e => console.log)
  },
  // generarPdf({ }, id) {
  //   var pdf = functions.httpsCallable('httpContratosGenerarPdf');
  //   return pdf(id)
  // }
  generarPdf({ }, id) {
    var datosContrato;
    var datosPlantilla;
    return db.collection('contratos').doc('contratos').collection('listado').doc(id).get()
      .then(r => {
        if (!r.exists) return Promise.reject("contrato no existe")
        datosContrato = {
          ...r.data(),
          id: r.id
        }
        return db.collection('contratos').doc('plantillas').collection('listado').doc(datosContrato.plantilla).get()
      })
      .then(p => {
        if (!p.exists) return Promise.reject("plantilla no existe")
        datosPlantilla = {
          ...p.data(),
          id: p.id
        }
        var doc = new jsPDF('p')
        let plantilla = datosPlantilla.texto;

        datosContrato.variables.forEach(v => {
          plantilla = plantilla.replaceAll('{{' + v.variable + '}}', v.valor.length > 0 ? v.valor : '___')
        })
        var margins = {
          top: 40,
          bottom: 40,
          left: 40,
          width: 522
        };
        doc.fromHTML(plantilla, 15, 15, {
          'width': 170
        },
          function (dispose) {
            // dispose: object with X, Y of the last line add to the PDF
            //          this allow the insertion of new lines after html
            //doc.save("Test.pdf");
          },
          margins)
        var pdfResumen = doc.output('dataurlnewwindow')
        // let destino = 'contratos/' + datosContrato.cliente + '/' + datosContrato.nombre + '.pdf';
        // var refResumen = storage.ref(destino)
        // return refResumen.put(pdfResumen).then((r) => r.ref.getDownloadURL());

      })
  },
  verPdfPlantilla({ }, datosPlantilla) {
    var pdf = functions.httpsCallable('httpContratosVerPdfPlantilla');
    return pdf(datosPlantilla.value)
      .then(() => {
        var pdfRef = storage.ref('contratos/plantillas/' + datosPlantilla.value + '.pdf');
        return pdfRef.getDownloadURL();
      })
  }
}